import { render, staticRenderFns } from "./termos.vue?vue&type=template&id=6bd9ac0c&scoped=true"
import script from "./termos.vue?vue&type=script&lang=js"
export * from "./termos.vue?vue&type=script&lang=js"
import style0 from "./termos.vue?vue&type=style&index=0&id=6bd9ac0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9ac0c",
  null
  
)

export default component.exports